import { CustomerRegistrationCountry } from "libs/tm-common/src/lib/models/customer-registration.model";

// list of all allowed countries (sorted by ISO Code)
export const RegistrationCountries: CustomerRegistrationCountry[] = [
    { country: "Austria", code: "AT" },
    { country: "Belgium", code: "BE" },
    { country: "Brazil", code: "BR" },
    { country: "Bulgaria", code: "BG" },
    { country: "Switzerland", code: "CH" },
    { country: "Cyprus", code: "CY" },
    { country: "Czech Republic", code: "CZ" },
    { country: "Germany", code: "DE" },
    { country: "Denmark", code: "DK" },
    { country: "Estonia", code: "EE" },
    { country: "Spain", code: "ES" },
    { country: "Finland", code: "FI" },
    { country: "Faroe Islands", code: "FO" },
    { country: "France", code: "FR" },
    { country: "United Kingdom", code: "GB" },
    { country: "Greece", code: "GR" },
    { country: "Hong Kong SAR", code: "HK" },
    { country: "Croatia", code: "HR" },
    { country: "Hungary", code: "HU" },
    { country: "Ireland", code: "IE" },
    { country: "Israel", code: "IL" },
    { country: "Italy", code: "IT" },
    { country: "Kazakhstan", code: "KZ" },
    { country: "Liechtenstein", code: "LI" },
    { country: "Lithuania", code: "LT" },
    { country: "Luxembourg", code: "LU" },
    { country: "Latvia", code: "LV" },
    { country: "Malta", code: "MT" },
    { country: "Netherlands", code: "NL" },
    { country: "Norway", code: "NO" },
    { country: "New Zealand", code: "NZ" },
    { country: "Poland", code: "PL" },
    { country: "Portugal", code: "PT" },
    { country: "Romania", code: "RO" },
    { country: "San Marino", code: "SM" },
    { country: "Sweden", code: "SE" },
    { country: "Slovenia", code: "SI" },
    { country: "Slovakia", code: "SK" },
    { country: "Thailand", code: "TH" },
    { country: "Tanzania", code: "TZ" },
    { country: "Ukraine", code: "UA" },
    { country: "Vatican City", code: "VA" }
];
